import { FC } from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Button } from '@microservices/wiskey-react-components'
import { Add } from '@mui/icons-material'
import { Grid } from '@mui/material'

import { Action } from '@pages/WindowsCreateOrEdit/components/Action/Action'
import { getEmptyAction } from '@pages/WindowsCreateOrEdit/components/helpers/getDefaultValuesWindow'
import { ArraySectionsType } from '@pages/WindowsCreateOrEdit/types'

type ActionsProps = {
  sectionIndex: number
  tabIndex: number
}

export const Actions: FC<ActionsProps> = ({ sectionIndex, tabIndex }) => {
  const { t } = useTranslation()
  const { control } = useFormContext<ArraySectionsType>()

  const {
    fields: actions,
    append,
    remove,
  } = useFieldArray({
    control,
    name: `sections.${sectionIndex}.tabs.${tabIndex}.actions` as const,
  })

  const handleAddAction = () => {
    const emptyValue = getEmptyAction()
    append(emptyValue)
  }

  const handleRemoveAction = (index: number) => {
    remove(index)
  }

  return (
    <>
      {actions.map((field, index) => (
        <Action
          key={field.id}
          actionIndex={index}
          removeAction={handleRemoveAction}
          sectionIndex={sectionIndex}
          tabIndex={tabIndex}
        />
      ))}
      <Grid container justifyContent={'flex-end'} pb={1} width={'100%'}>
        <Button onClick={handleAddAction}>
          <Add fontSize='small' />
          {t('window.buttons.addAction')}
        </Button>
      </Grid>
    </>
  )
}
